import { Flex, Text, Tooltip, useMediaQuery } from "@chakra-ui/react";
import React from "react";
import AppSelect from "./AppSelect";
import { FiAlertTriangle } from "react-icons/fi";
import CustomBox from "../views/roster/common/CustomBox";

interface IProps {
  readonly children?: React.ReactNode;
  readonly tabs: {
    name: string;
    value: string;
    icon?: JSX.Element;
    index?: number;
    alertInfo?: string;
    dot?: {
      color: string;
      background: string;
    };
  }[];
  readonly value: string;
  readonly setValue: (value: string) => void;
  readonly mb?: string;
}
function AppTabs(props: IProps) {
  const { children, setValue, value, tabs, mb } = props;
  const [isMobile] = useMediaQuery("(max-width: 800px)");
  return (
    <Flex
      justifyContent={"space-between"}
      alignItems={"center"}
      mb={mb ? mb : "4"}
      minHeight={"40px"}
    >
      {tabs.length > 6 || isMobile ? (
        <AppSelect
          onChange={(v) => setValue(v)}
          options={(tabs?.length && Number(tabs[0].index) >= 0
            ? [...tabs.sort((a, b) => (a.index ?? 0) - (b.index ?? 0))]
            : [...tabs.sort((a, b) => a.name.localeCompare(b.name))]
          ).map(({ name, value }) => ({
            label: name,
            value,
          }))}
          value={value}
        />
      ) : (
        <Flex background={"gray.50"}>
          {(tabs?.length && Number(tabs[0].index) >= 0
            ? [...tabs.sort((a, b) => (a.index ?? 0) - (b.index ?? 0))]
            : [...tabs]
          ).map((obj, i) => (
            <Flex
              key={obj.value}
              onClick={() => setValue(obj.value)}
              borderBottom={"2px solid"}
              borderColor={value === obj.value ? "black" : "gray.200"}
              px={"3"}
              py={"2"}
              transition={"0.3s"}
              cursor={"pointer"}
              alignItems={"center"}
              data-testid={obj.value}
            >
              {obj.icon ? (
                <Text
                  mr={"2"}
                  color={value === obj.value ? "black" : "gray.500"}
                >
                  {obj.icon}
                </Text>
              ) : null}
              {obj.dot ? (
                <Flex mr={"2"}>
                  <CustomBox
                    size={8}
                    background={obj.dot.background}
                    color={obj.dot.color}
                  />
                </Flex>
              ) : null}
              <Text
                fontSize={"14px"}
                color={value === obj.value ? "black" : "gray.500"}
                fontWeight={"medium"}
              >
                {obj.name}
              </Text>
              {obj.alertInfo ? (
                <Tooltip label={obj.alertInfo}>
                  <Text
                    ml={"1"}
                    color={value === obj.value ? "black" : "gray.500"}
                  >
                    <FiAlertTriangle />
                  </Text>
                </Tooltip>
              ) : null}
            </Flex>
          ))}
        </Flex>
      )}

      <Flex>{children}</Flex>
    </Flex>
  );
}

export default AppTabs;
